import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    MdOutlineBarChart,
    MdOutlineTimer
} from 'react-icons/md';
import Button from 'components/Button';
import './index.css';

type DigitalInstructionProps = {
    testName: string;
    beginTest: () => void;
};

function DigitalBCAInstruction({ testName, beginTest }: DigitalInstructionProps) {
    const navigate = useNavigate();

    return (
        <div className='bcaInstruction'>
            <h1 className='bcaInstruction__heading'>
                {testName}
            </h1>
            <div className='bcaInstruction__items'>
                <h2 className='bcaInstruction__itemTitle'>
                    <MdOutlineTimer className='bcaInstruction__itemIcon' />
                    Timing
                </h2>
                <p className='bcaInstruction__itemContent'>
                    This test has 40 math questions and a 60-minute time limit. Calculators are not permitted. You can pause any time, but if you continue on a different device, you'll need to start over.
                </p>
                <h2 className='bcaInstruction__itemTitle'>
                    <MdOutlineBarChart className='bcaInstruction__itemIcon' />
                    Scores
                </h2>
                <p className='bcaInstruction__itemContent'>
                    Each correct answer earns 2 points, each incorrect answer loses 0.5 point, and a question left blank earns 0 points.
                </p>
            </div>
            <div className='bcaInstruction__buttons'>
                <Button
                    className='bcaInstruction__button'
                    secondary
                    onClick={() => navigate(-1)}
                >
                    EXIT
                </Button>
                <Button
                    className='bcaInstruction__button'
                    onClick={beginTest}
                >
                    NEXT
                </Button>
            </div>
        </div>
    );
}

export default DigitalBCAInstruction;